import { connect } from 'react-redux';
import { selectUserType } from 'redux/selectors/auth';
import { StateType } from 'types';

const mapStateToProps = (state: StateType) => ({
  userType: selectUserType(state),
});

export default connect(mapStateToProps);
